import script from "./WaitlistMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./WaitlistMonitor.vue?vue&type=script&setup=true&lang=js"

import "./WaitlistMonitor.vue?vue&type=style&index=0&id=48f23514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f23514"]])

export default __exports__